<template>
    <span :id="id" class="anchor-tag__icon">
        
    </span>
</template>
<script setup lang="ts">
import type { AnchorTagModel } from '~/models';
const props = defineProps<{ model: AnchorTagModel | null }>();
const id = props.model?.elements.id.value;
</script>
<style lang="scss" scoped>
.docon-link::before {
    content: "";
}
</style>